'use strict';

const axios = require('axios').default;

class api {
    constructor(conection) {
        this.conection = conection;
        this.interceptors = axios.interceptors;
        this.headers = axios.defaults.headers;
    }

    register(userToRegister, callbackOK, callbackKO, callbackEND) {
        return this.commonAxios('/v1/user/register', 'post', userToRegister, callbackOK, callbackKO, callbackEND);
    }

    userVerify(model, callbackOK, callbackKO, callbackEND) {
        return this.commonAxios('/v1/user/verify', 'post', model, callbackOK, callbackKO, callbackEND);
    }

    login(user, pass, callbackOK, callbackKO, callbackEND) {
        return this.commonAxios(
            '/v1/user/login',
            'post',
            {
                email: user,
                password: pass,
            },
            callbackOK,
            callbackKO,
            callbackEND
        );
    }

    remember(model, callbackOK, callbackKO, callbackEND) {
        return this.commonAxios('/v1/user/remember', 'post', model, callbackOK, callbackKO, callbackEND);
    }

    verifyRegister(token, callbackOK, callbackKO, callbackEND) {
        return this.commonAxios('/v1/user/verify', 'put', token, callbackOK, callbackKO, callbackEND);
    }

    verifyEmail(token, callbackOK, callbackKO, callbackEND) {
        return this.commonAxios('/v1/user/email', 'put', token, callbackOK, callbackKO, callbackEND);
    }

    recover(model, callbackOK, callbackKO, callbackEND) {
        return this.commonAxios('/v1/user/recover', 'put', model, callbackOK, callbackKO, callbackEND);
    }

    getUser(callbackOK, callbackKO, callbackEND) {
        return this.commonAxios('/v1/user', 'get', null, callbackOK, callbackKO, callbackEND);
    }

    updateUser(objUser, callbackOK, callbackKO, callbackEND) {
        return this.commonAxios('/v1/user', 'put', objUser, callbackOK, callbackKO, callbackEND);
    }

    deleteUser(objUser, callbackOK, callbackKO, callbackEND) {
        return this.commonAxios('/v1/user', 'delete', objUser, callbackOK, callbackKO, callbackEND);
    }

    updateProfile(objUser, callbackOK, callbackKO, callbackEND) {
        return this.commonAxios('/v1/profile', 'put', objUser, callbackOK, callbackKO, callbackEND);
    }

    getWeather(location, callbackOK, callbackKO, callbackEND) {
        return this.commonAxios('/v1/weather', 'get', { location_id: location }, callbackOK, callbackKO, callbackEND);
    }

    getLocations(callbackOK, callbackKO, callbackEND) {
        return this.commonAxios('/v1/locations', 'get', null, callbackOK, callbackKO, callbackEND);
    }

    getLocation(location, callbackOK, callbackKO, callbackEND) {
        return this.commonAxios(`/v1/locations/${location}`, 'get', null, callbackOK, callbackKO, callbackEND);
    }

    updateLocation(location, callbackOK, callbackKO, callbackEND) {
        return this.commonAxios(`/v1/locations/${location.id}`, 'put', location, callbackOK, callbackKO, callbackEND);
    }

    createLocation(location, callbackOK, callbackKO, callbackEND) {
        return this.commonAxios('/v1/locations', 'post', location, callbackOK, callbackKO, callbackEND);
    }

    deleteLocation(location, callbackOK, callbackKO, callbackEND) {
        return this.commonAxios(`/v1/locations/${location}`, 'delete', null, callbackOK, callbackKO, callbackEND);
    }

    getSpaces(location, intallation, callbackOK, callbackKO, callbackEND) {
        return this.commonAxios(
            '/v1/spaces',
            'get',
            { location_id: location, installation_ref: intallation },
            callbackOK,
            callbackKO,
            callbackEND
        );
    }

    deleteSpace(space, callbackOK, callbackKO, callbackEND) {
        return this.commonAxios(`/v1/spaces/${space}`, 'delete', null, callbackOK, callbackKO, callbackEND);
    }

    createSpace(space, callbackOK, callbackKO, callbackEND) {
        return this.commonAxios('/v1/spaces', 'post', space, callbackOK, callbackKO, callbackEND);
    }

    updateSpace(space, callbackOK, callbackKO, callbackEND) {
        return this.commonAxios(`/v1/spaces/${space.id}`, 'put', space, callbackOK, callbackKO, callbackEND);
    }

    getInstallations(location, callbackOK, callbackKO, callbackEND) {
        return this.commonAxios(
            '/v1/installations',
            'get',
            { location_id: location, validated: 1 },
            callbackOK,
            callbackKO,
            callbackEND
        );
    }

    addInstallation(installation, callbackOK, callbackKO, callbackEND) {
        return this.commonAxios('/v1/installations', 'post', installation, callbackOK, callbackKO, callbackEND);
    }

    deleteInstallation(installation, callbackOK, callbackKO, callbackEND) {
        return this.commonAxios(
            `/v1/installations/${installation.reference}`,
            'delete',
            null,
            callbackOK,
            callbackKO,
            callbackEND
        );
    }

    updateInstallation(installation, callbackOK, callbackKO, callbackEND) {
        return this.commonAxios(
            `/v1/installations/${installation.reference}`,
            'put',
            installation,
            callbackOK,
            callbackKO,
            callbackEND
        );
    }

    getDevices(installation, callbackOK, callbackKO, callbackEND) {
        return this.commonAxios(
            '/v1/devices',
            'get',
            { installation_ref: installation },
            callbackOK,
            callbackKO,
            callbackEND
        );
    }

    updateDevice(device, callbackOK, callbackKO, callbackEND) {
        return this.commonAxios(`/v1/devices/${device.reference}`, 'put', device, callbackOK, callbackKO, callbackEND);
    }

    deleteDevice(device, callbackOK, callbackKO, callbackEND) {
        return this.commonAxios(
            `/v1/devices/${device.reference}`,
            'delete',
            device,
            callbackOK,
            callbackKO,
            callbackEND
        );
    }

    getFavourites(callbackOK, callbackKO, callbackEND) {
        return this.commonAxios(`/v1/devices?is_favourite=1`, 'get', null, callbackOK, callbackKO, callbackEND);
    }

    addFavourite(device, callbackOK, callbackKO, callbackEND) {
        return this.commonAxios('/v1/favourites', 'post', device, callbackOK, callbackKO, callbackEND);
    }

    deleteFavourite(device, callbackOK, callbackKO, callbackEND) {
        return this.commonAxios(
            `/v1/favourites/${device.reference}`,
            'delete',
            device,
            callbackOK,
            callbackKO,
            callbackEND
        );
    }

    // getThermostats(installation, callbackOK, callbackKO, callbackEND) {
    //     return this.commonAxios(`/v1/installations/${installation}/thermostats`, 'get', null, callbackOK, callbackKO, callbackEND)
    // }

    instruction(instruction, callbackOK, callbackKO, callbackEND) {
        return this.commonAxios('/v1/send/instruction', 'post', [instruction], callbackOK, callbackKO, callbackEND);
    }

    refreshTokens(token, callbackOK, callbackKO, callbackEND) {
        return this.commonAxios(
            `/v1/user/refreshtokens`,
            'put',
            { refresh_token: token },
            callbackOK,
            callbackKO,
            callbackEND
        );
    }

    refreshAwsCredentials(callbackOK, callbackKO, callbackEND) {
        return this.commonAxios(`/v1/user/refreshawscredentials`, 'put', null, callbackOK, callbackKO, callbackEND);
    }

    adddParametes(url, parameters) {
        Object.keys(parameters).forEach((key) => {
            if (parameters[key] === null) delete parameters[key];
        });
        let strParameters = Object.keys(parameters)
            .map((key) => `${key}=${parameters[key]}`)
            .join('&');
        if (strParameters.length > 0) return `${url}?${strParameters}`;
        else return url;
    }

    commonAxios(url, method, data, callbackOK, callbackKO, callbackEND) {
        if (method.toLocaleLowerCase() == 'get' && data != null) {
            url = this.adddParametes(url, data);
            data = null;
        }
        return axios({
            method: method,
            url: `${this.conection}${url}`,
            data: data,
        })
            .then((response) => {
                if (callbackOK) callbackOK(response.data);
            })
            .catch((error) => {
                dd('error');
                dd(error);
                if (!error.response.data.error) error.response.data.error = 'EFE';
                if (callbackKO) callbackKO(error.response);
            })
            .finally((end) => {
                if (callbackEND) callbackEND(end);
            });
    }

    axios(config) {
        return axios(config);
    }
}

export default api;
